import { ColourBox } from './colour';
import { DragAndDrop } from './drag_and_drop';
import { HTMLTextArea } from './html_text_area';
import { Dialog } from './dialog/dialog';
import { DialogManager } from './dialog/dialog_manager';

const dialog = (options) => new Dialog(options);
const dialog_manager = (options) => new DialogManager(options);


const control = {
	ColourBox,
	DragAndDrop,
	HTMLTextArea,
	dialog,
	dialog_manager
}

export {
	control
}